import React, {Component} from "react";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import ReadMore from "../ReadMore/ReadMore";
import "./AssetDetails.scss";
import AmbassadorHelper from "../../utils/AmbassadorHelper";
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import common from "../../utils/common";

class AssetDetails extends Component {
    state = {
        ambassador: null
    }

    render() {
        const {asset, enableAmbassador, ambassador, publishedDate, userTotalVideos} = this.props;
        const isAmbassadorAvailable = enableAmbassador && (ambassador !== null);
        return <Grid xs={12} sm={9} className={"tabs"}>
            <ReadMore
                lines={3}
                transcripts={asset.data.transcripts}
                more="More"
                less="Less">
                {asset && asset.description}
            </ReadMore>
            <div className={"asset-meta ambassador-desktop"}>
                <div className={"flex-child "}>
                    {isAmbassadorAvailable && <div className={"ambassador-profile"}>
                        <a href={common.generateAmbassadorUrl(ambassador)}>
                            <Avatar sx={{ width: 40, height: 40 }} src={AmbassadorHelper.getAmbassadorPhoto(ambassador)} alt={AmbassadorHelper.getDisplayNameFromApi(ambassador)} />
                            <div className={"ambassador-profile-name"}>
                                By {AmbassadorHelper.getDisplayNameFromApi(ambassador)}
                                <div className={"published"}>
                                    {userTotalVideos && <span>{userTotalVideos} Item{userTotalVideos > 1 ? "s" : ""}</span>}
                                    &nbsp;•&nbsp;
                                    <span>Published: {publishedDate ?? ""}</span>
                                </div>
                            </div>
                        </a>
                    </div>}
                </div>

            </div>
            <div className={"ambassador-mobile"}>
                <div>
                    {isAmbassadorAvailable && <div className={"ambassador-mobile-profile"}>
                        <a href={`${ClientConfigurationHelper.getGlobalConfiguration().sub_folder}/a/${ambassador.user_slug}/${ambassador.user_id}`} className={"col-12"}>
                            <Avatar sx={{ width: 40, height: 40 }} src={AmbassadorHelper.getAmbassadorPhotoFromApi(ambassador)} alt={AmbassadorHelper.getDisplayNameFromApi(ambassador)} />
                            <div className={"ambassador-mobile-profile-name"}>
                                By {AmbassadorHelper.getDisplayNameFromApi(ambassador)}
                                <Grid container>
                                    <div className="time-date-container">
                                        <div className="tvp-published">
                                            {userTotalVideos && <span>{userTotalVideos} Item{userTotalVideos > 1 ? "s" : ""}</span>}
                                            &nbsp;•&nbsp;
                                            <span>Published: {publishedDate ?? ""}</span>
                                        </div>
                                    </div>
                                </Grid>
                            </div>
                        </a>
                    </div>}
                </div>
            </div>
        </Grid>
    }
}

AssetDetails.defaultProps = {
    enableAmbassador: ClientConfigurationHelper.isAmbassadorProgramEnabled(),
    ambassador: null
};

export default AssetDetails;